import {useState} from 'react'

import PropTypes from 'prop-types'

import FormSelectToggle from '@adv-mt/mt-form-select-toggle'

import {BASE_CLASS} from '../../config.js'
import {COMPONENTS, DEFAULT_TYPE, OPTIONS} from './config.js'

const FormLocationContent = ({aggregations, autoFocus, design, isLoading, onChange, search}) => {
  const [locationFormType, setLocationFormType] = useState(DEFAULT_TYPE)

  const FormLocationComponent = COMPONENTS[locationFormType]

  const handleChangeLocationType = (_, {value}) => {
    value && value !== locationFormType && setLocationFormType(value)
  }

  const handleSelectLocation = (_, location) => onChange(_, location)

  return (
    <div className={`${BASE_CLASS}Content`}>
      <FormSelectToggle options={OPTIONS} value={locationFormType} onChange={handleChangeLocationType} />
      <FormLocationComponent
        autoFocus={autoFocus}
        aggregations={aggregations}
        design={design}
        isLoading={isLoading}
        onChange={handleSelectLocation}
        search={search}
        withLabel={false}
      />
    </div>
  )
}

FormLocationContent.displayName = 'FormLocationContent'
FormLocationContent.propTypes = {
  aggregations: PropTypes.array,
  autoFocus: PropTypes.bool,
  design: PropTypes.string,
  isLoading: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  search: PropTypes.object
}

export default FormLocationContent
